import { insertCodeTab } from './operations';

const slashMenu = {
  Code: { icon: 'code', basic: true, shortcut: '```', transform: insertCodeTab },
};

export default slashMenu;
